// extracted by mini-css-extract-plugin
export default {"container":"vqhSDc","separator":"tHfWUa","arrow":"s21xJe","container--mobile":"sNxWR6"};